import { render, staticRenderFns } from "./DeletedMessageBalloon.vue?vue&type=template&id=0ceb1478&scoped=true&"
import script from "./DeletedMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./DeletedMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./DeletedMessageBalloon.vue?vue&type=style&index=0&id=0ceb1478&lang=less&scoped=true&"
import style1 from "./DeletedMessageBalloon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceb1478",
  null
  
)

export default component.exports